import React, { useContext } from "react"
import tw, { css } from "twin.macro"
import { ReactComponent as WhiteLogo } from "../../assets/logo/bonsai-white-logo.svg"
import { MainLogo } from "../bonsaiLogo"
import { SearchBar } from "./searchBar"
import { ProfileNav } from "./profileNav"
import { AuthContext } from "../../utils/context"
import Skeleton from "./skeleton"
import { LoggedOut } from "./loggedOut"
import Link from "next/link"
import { ActivityIcon } from "./activityIcon"

export interface NavBarProp {
  isblack?: boolean
}

const NavObjects = ({ isblack }: NavBarProp) => {
  const { preflightData, token } = useContext(AuthContext)
  if (!preflightData) {
    return <Skeleton />
  }
  if (!token) {
    return <LoggedOut {...{ isblack }} />
  } else {
    return (
      <>
        <ActivityIcon {...{ isblack }} />
        <ProfileNav {...{ isblack }} />
      </>
    )
  }
}

const NavBar = ({ isblack }: NavBarProp) => {
  return (
    <nav
      data-testid="navbar"
      tw="z-20 transition-shadow delay-75 w-full h-auto sticky top-0 flex-grow-0"
      css={[
        isblack
          ? [
              tw`bg-base-6`,
              css`
                box-shadow: 0px 0px 12px #000000;
              `,
            ]
          : tw`bg-background shadow-base-2`,
      ]}
    >
      <div tw="flex items-center justify-between max-w-screen-desktop-lg m-auto py-3.5 px-4 tablet-lg:py-2.5 relative">
        {isblack ? (
          <Link href={"/"} passHref>
            <a>
              <WhiteLogo tw="w-[118px] h-[24px] tablet-lg:(w-[158px] h-[32px])" />
            </a>
          </Link>
        ) : (
          <MainLogo linked={true} />
        )}
        {!isblack && <SearchBar />}
        <NavObjects isblack={isblack} />
      </div>
    </nav>
  )
}

export default NavBar
